module.exports = __webpack_public_path__ + "img/chat-blue.ed3d4f8a.svg";